/**
 * 读取文本文件并做字数校验
 * @param {File} file 文件对象
 * @param {Object} options 配置
 * @param {number} [options.maxLength=30000] 最大字符数
 * @returns {Promise<{ text: string, length: number }>}
 */
export function readTextFileWithLimit (file, options) {
  var opts = options || {}
  var maxLength = typeof opts.maxLength === 'number' ? opts.maxLength : 30000

  return new Promise(function (resolve, reject) {
    if (!file) {
      reject(new Error('未选择文件'))
      return
    }

    var reader = new FileReader()

    reader.onload = function (evt) {
      var text = typeof evt.target.result === 'string' ? evt.target.result : ''
      var length = text.length
      if (length > maxLength) {
        var err = new Error('上传文件字数已超过 ' + maxLength + ' 字，请裁剪内容后重新上传。')
        err.code = 'FILE_TOO_LARGE'
        err.length = length
        reject(err)
        return
      }
      resolve({ text: text, length: length })
    }

    reader.onerror = function () {
      reject(new Error('无法读取所选文件，请稍后重试或更换文件。'))
    }

    reader.readAsText(file)
  })
}

